import React, { useMemo, useState } from "react";
import { Consult } from "../../components/Consult";
import dayjs from "dayjs";
import { Button } from "antd";
import { request } from "../../functions/request";
import { Content } from "antd/es/layout/layout";
import { AiFillEdit, AiFillEye } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaArrowAltCircleUp } from "react-icons/fa";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function ConsultNoticiasAgendadas() {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [data, setData] = useState([]);
  const [modalContent, setModalContent] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const columns = useMemo(
    () => [
      {
        accessorKey: "not_numero",
        header: "ID",
        size: 40,
      },
      {
        accessorKey: "not_titulo",
        header: "Título",
        size: 60,
      },
      {
        accessorKey: "not_lead",
        header: "Lead",
        size: 100,
      },
      {
        accessorKey: "not_data",
        header: "Agendada para",
        size: 60,
      },
      {
        accessorKey: "not_secao",
        header: "Seção",
        size: 60,
        filterVariant: "multi-select",
      },
    ],
    []
  );

  const transformSectionComent = (section) => {
    switch (section) {
      case 1:
        return "Boi";
      case 2:
        return "Frango";
      case 3:
        return "Grãos";
      case 4:
        return "Leite";
      case 5:
        return "Suínos";
      case 8:
        return "Agroações";
      case 9:
        return "Bolsas e Opções";
      default:
        return "Outros";
    }
  };

  function refreshPage(path = 0, timeout = 1000) {
    setTimeout(() => {
      navigate(path, { replace: true });
    }, timeout);
  }

  const publishNow = (not_numero) => {
    // Endpoint proprio de "publicar agora": alem de ativar, zera o
    // agendamento e carimba a data da publicacao real. Com o
    // updateNoticiasActive a materia saia no site com a data futura do
    // agendamento e continuava listada como agendada.
    request(`/noticia/publicarAgoraNoticia/${not_numero}`, {
      method: "PUT",
    }).finally(() => {
      toast.success("Notícia publicada com sucesso!");
      refreshPage("/noticia-agendadas");
      fetchData();
    });
  };

  const cancelSchedule = (not_numero) => {
    request(`/noticia/cancelarAgendamentoNoticia/${not_numero}`, {
      method: "PUT",
    }).finally(() => {
      toast.success("Agendamento cancelado — a notícia voltou pra aprovação.");
      refreshPage("/noticia-agendadas");
      fetchData();
    });
  };

  const fetchData = async () => {
    try {
      setHasError(false);
      setIsLoading(true);
      await request(`/noticia/getnoticiasagendadas`, {
        method: "GET",
      })
        .then((response) => {
          const arr = Array.isArray(response) ? response : response?.[0];
          if (!Array.isArray(arr)) {
            setData([]);
            setHasError(true);
            return;
          }
          const formattedData = arr.map((res) => {
            res.not_data = dayjs(res?.not_data).format("DD/MM/YYYY HH:mm");
            res.not_secao = transformSectionComent(res?.not_secao);
            return res;
          });
          if (formattedData.length <= 0) {
            setData([]);
            setHasError(true);
          } else {
            setData(formattedData);
          }
        })
        .finally(() => {
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setData([]);
          setIsLoading(false);
          setHasError(true);
        });
    } catch (error) {
      console.error("Erro na requisição:", error);
      setData([]);
      setIsLoading(false);
      setHasError(true);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <Content>
      <Consult.Table
        data={data}
        columns={columns}
        isLoading={isLoading}
        hasError={hasError}
        style={{ width: "100%", minWidth: "100%" }}
        initialState={{
          showColumnFilters: true,
          pagination: { pageIndex: 0, pageSize: 100 },
        }}
        renderRowActions={({ row }) => (
          <Content
            style={{
              display: "flex",
              gap: "5px",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                setModalContent(row.original);
                setIsModalOpen(true);
              }}
              icon={<AiFillEye />}
            >
              Visualizar
            </Button>
            <Link to={`/editor-noticia/${row.original.not_numero}`}>
              <Button icon={<AiFillEdit />}>Editar</Button>
            </Link>
            <Button
              color="default"
              variant="solid"
              icon={<FaArrowAltCircleUp />}
              onClick={() => publishNow(row.original.not_numero)}
            >
              Publicar Agora
            </Button>
            <Button
              danger
              icon={<CloseCircleOutlined />}
              onClick={() => cancelSchedule(row.original.not_numero)}
            >
              Cancelar Agendamento
            </Button>
          </Content>
        )}
      />
      <Consult.Modal
        title={modalContent?.not_titulo}
        date={modalContent?.not_data}
        text={modalContent?.not_texto}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
      />
    </Content>
  );
}
